module.exports = __webpack_public_path__ + "static/img/logo_light.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_light.png
// module id = nlQa
// module chunks = 0